import React from 'react';
import { ApolloProvider } from '@apollo/client';
import useSetApolloCache from 'appDir/routes/useSetApolloCache';
import apolloClient from 'appDir/lib/apollo/client';

interface ApolloProviderWrapperProps {
  railsContext: any;
  children: any;
}

const ApolloProviderWrapped = ({
  railsContext,
  children,
}: ApolloProviderWrapperProps) => {
  const cacheLoaded = useSetApolloCache(railsContext);
  if (!cacheLoaded) return null;
  return children;
};

const ApolloProviderWrapper = (props: ApolloProviderWrapperProps) => {
  return (
    <ApolloProvider client={apolloClient}>
      <ApolloProviderWrapped {...props} />
    </ApolloProvider>
  );
};

export default ApolloProviderWrapper;
